import { render, staticRenderFns } from "./ApeUploader.vue?vue&type=template&id=3879fab1"
import script from "./ApeUploader.vue?vue&type=script&lang=js"
export * from "./ApeUploader.vue?vue&type=script&lang=js"
import style0 from "./ApeUploader.vue?vue&type=style&index=0&id=3879fab1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports